// Components
// Utils
import { getText } from 'i18n/intl';
import { TEDrawerSection, TEInput } from '@timeedit/ui-components';
// Types
import type { IProps } from './sections.interface';
// Styles
import './GeneralInfo.scss';

const GeneralInfo = ({ availabilityRelation, onChange }: IProps) => {
  return (
    <TEDrawerSection label="General info">
      <div className="availability-relation-general-info">
        <TEInput.Input
          label="Name"
          tooltip="Name"
          value={availabilityRelation.name}
          onChange={(val) => onChange('name', val)}
          placeholder={getText('new_availability_relation')}
          data-testid="availability-name"
        />
        <TEInput.Input
          label="Ext. ID"
          tooltip="Ext. ID"
          value={availabilityRelation.extId}
          onChange={(val) => onChange('extId', val)}
          data-testid="ext-id"
        />
        <TEInput.Switch
          label="Constitutes obstacle"
          tooltip="Constitutes obstacle"
          checked={availabilityRelation.constitutesObstacles}
          onChange={(val) => onChange('constitutesObstacles', val)}
          data-testid="constitutes-obstacle"
        />
        <TEInput.Switch
          label="Occupied by default"
          tooltip="Occupied by default"
          checked={availabilityRelation.occupiedByDefault}
          onChange={(val) => onChange('occupiedByDefault', val)}
          data-testid="occupied-default"
        />
        <TEInput.PureText
          label="Id"
          tooltip="Id"
          value={String(availabilityRelation.id)}
        />
      </div>
    </TEDrawerSection>
  );
};

export default GeneralInfo;
